<template>
  
  <v-dialog v-model="dialog" v-if="!$store.getters.isLoggedIn" persistent max-width="375">
    <v-card>
      <v-card-text class="ma-0 pa-0">
        <div class=" pa-10 primary d-flex justify-center">
          <v-img class="white--text align-end" width="200" :src="require('../assets/pdv-manager.svg')" />
        </div>
        <div class="pa-5">
          <v-alert class="error" v-if="falhaLogin !== undefined">
            {{ falhaLogin }}
          </v-alert>
          <v-form @submit.prevent="login()">
            <v-text-field label="Usuário" name="usuario" prepend-inner-icon="mdi-account" type="text" v-model="username"/>
            <v-text-field id="password" label="Senha" name="password" prepend-icon="mdi-lock" type="password" v-model="password"/>
            <v-btn depressed block color="primary" type="submit" :disabled="processando">
              Entrar
              <v-icon>mdi-login-variant</v-icon>
            </v-btn>
          </v-form>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>

      <!--v-container class="fill-height">
        <v-row justify="center">
          <v-card>
            <v-card-text class="ma-0 pa-0">
              <div class="ma-0 pt-10 pb-10 pl-5 pr-5 primary">
                <v-img class="white--text align-end" width="250" :src="require('../assets/pdv-manager.svg')" />
              </div>
              <div class="pa-5">
                <v-form>
                  <v-text-field label="Usuário" name="usuario" prepend-inner-icon="mdi-account" type="text" v-model="username"/>
                  <v-text-field id="password" label="Senha" name="password" prepend-icon="mdi-lock" type="password" v-model="password"/>
                  <v-btn depressed block color="primary" @click="login()">
                    Entrar
                    <v-icon>mdi-login-variant</v-icon>
                  </v-btn>
                </v-form>
              </div>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container-->

    
   
  
      <!--v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" class="d-flex justify-center">
            <v-card color="primary"
              class="mx-auto my-12 pa-5"
              max-width="500" 
            >
              <v-card-text>

              <v-img class="white--text align-end" height="37px" :src="require('../assets/pdv-manager.svg')" />
                <v-form>
                  <v-text-field label="Usuário" name="usuario" prepend-inner-icon="mdi-account" type="text" v-model="username"/>
                  <v-text-field id="password" label="Senha" name="password" prepend-icon="mdi-lock" type="password" v-model="password"/>
                  <v-btn depressed block color="primary" @click="login()">
                    Entrar
                    <v-icon>mdi-login-variant</v-icon>
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container-->
</template>

<script>
  export default {
      name: 'Login',
      data(){
        return {
              dialog: true,
              falhaLogin: undefined,
              processando: false,
              username: '',
              password: '',

              align: ['center'],
              align_: [
        'start',
        'end',
        'center',
        'baseline',
        'stretch',
      ],

          }
      },
      methods : {
          login: function (){
            this.processando = true
              let username = this.username
              let password = this.password
              this.$store.dispatch('login', { username, password })
                .then(() => {this.$router.push('/'); this.processando = false})
                .catch(() => {this.falhaLogin = 'Usuário e/ou senha inválidos'; this.processando = false})
          }
      }
  }
</script>